<!-- existing router outlet -->
<!-- <router-outlet></router-outlet> -->

   <!-- <div  class="container-fluid">
    <div class="row"> -->

    
      <app-header class="p-0" *ngIf="showHeader"></app-header>

      <!-- <div class="row"> -->
      <!-- Main Content Area -->
      <div [ngClass]="((aiService.isOpen() && showHeader) ? 'col-lg-8' : 'col-lg-12')" class="col-12">
        <router-outlet></router-outlet>
      </div>

      <!-- AI Panel -->
      <!-- <div *ngIf="aiService.isOpen() && showHeader" class="col-lg-4 d-none d-lg-block">
        <app-askexpart [isOpen]="aiService.isOpen()"></app-askexpart>
      </div> -->
  


<!--   
       <div *ngIf="!isUser" class="loader-container overlay-loader">


     

      <div class="dot-loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
   -->
    

    
  <!-- </div> -->
  <!-- </div>
  </div> -->


<!-- Floating AI Button -->
<!-- <button
  *ngIf="showHeader"
  class="ask-ai-button"
  (click)="aiService.toggle()"
  aria-label="Ask AI">
  Ask <br> 
  Xpert
  
</button> -->



<!-- global toaster -->
<app-toast-container />
